module.exports = __webpack_public_path__ + "img/product_44.e31cb09.webp";